// Keep Vite's asset loading separate from the rendered catalog components.
// jsdom substitutes this stylesheet boundary, just as it does CSS imports.
import extBemCss from '../../../../extension/src/styles/bem.css?inline';
import { TOAST_CSS } from '@overlayqa/shared';

// The extension loads its host/reset styles before BEM; the catalog must too.
const overlayModules = import.meta.glob<string>('../../../../extension/src/content/overlay-styles.ts', { eager: true, import: 'OVERLAY_CSS' });
const extStyles = Object.values(overlayModules)[0] + '\n' + extBemCss + '\n' + TOAST_CSS;
export default extStyles;
